import _ from "lodash";

export default [
  '$q', '$scope', 'StateTerritoryData', 'CustomerService',
  class ChangeAddressController {
    constructor($q, $scope, StateTerritoryData, CustomerService) {
      this._$q = $q;
      this._$scope = $scope;
      this._customerService = CustomerService;

      this.countries = StateTerritoryData.getCountries();
      this.states = StateTerritoryData.getExtendedStates();
      this.provinces = StateTerritoryData.getProvinces();
    }

    show(e, orderNum) {
      let order = this.orderObject.base.order_num === orderNum ? this.orderObject.base : _.find(this.orderObject.upsells, upsell => upsell.order_num === orderNum);

      if (order && order.can_update_address) {
        this.toggle = true;
        this._getStateFromAddress(order.order_customer);
      }
    }

    close() {
      this.toggle = false;
    }

    save() {
      if (this.changeAddress.$valid) {
        this.submitState = 'loading';

        this.updateAddress()
          .then(res => {
            this.customer.name = res.name;
            this.customer.address.street_1 = res.address.street_1;
            this.customer.address.street_2 = res.address.street_2;
            this.customer.address.city = res.address.city;
            this.customer.address.state = res.address.state;
            this.customer.address.zip = res.address.zip;

            this.originalZip = res.address.zip;
            this.submitState = 'success';
            this.close();
          })
          .catch(() => this.submitState = 'error');
      }
    }

    updateAddress() {
      return this._customerService.updateAddress(this.customer.id, {
        name: this.customer.name,
        'street_address_1': this.street_1,
        'street_address_2': this.street_2,
        'city': this.city,
        'state': this.state,
        'zip': this.zip,
        'original_zip': this.originalZip,
        'country': this.country
      })
    }

    countryChanged() {
      this.state = '';
      this.zip = '';
    }

    _getStateFromAddress(customer) {
      _.assign(this, customer.address);

      this.customer = customer;
      this.originalZip = customer.address.zip;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/change-address/change-address.ctrl.js